<mat-card style="border-color: #5775a8;">

  <mat-card-header>

    <div class="flex flex-col rounded-lg w-full">
      <div class="flex flex-row rounded-lg w-full"
        style="background-color: #5775a8;padding-left: 20px;align-items: center;">
        <div class="flex w-full">
          <span style="color: white;">
            Enclosed Area
          </span>
        </div>

        <div class="flex flex-col" style="padding-right: 20px;">
          <button mat-raised-button (click)="reportEnclosedArea()" class="m-8 container" style="background: #7ABDF3;">
            Report an Enclosed Area
          </button>
        </div>
      </div>
      <div *ngIf="isAdmin && enclosedArea.currentEnclosedArea != null" class="flex flex-col w-full">
        <div
          *ngIf="enclosedArea.currentEnclosedArea.enclosedArea && (enclosedArea.currentEnclosedArea.enclosedAreaReviewed == null || enclosedArea.currentEnclosedArea.enclosedAreaReviewed == false)">
          <br />
          <div *ngIf="enclosedArea.currentEnclosedArea.enclosedArea">
            <span class="text-danger" style="font-size: smaller;color:red;font-weight: bold;">
              Send Form(s) A, photos, video and any other required documentation to OHA within 2 business days of
              reporting the enclosed area.
              <br />This site visit will not be unlocked until enclosed area determination is made.
            </span>
          </div>
        </div>
      </div>
    </div>
  </mat-card-header>

  <mat-card-content>
    <br />
    <mat-card>
      <div class="flex flex-col" style="overflow-x:auto">
        <div class="flex flex-row">

          <table mat-table [dataSource]="dataSource" multiTemplateDataRows matSort fxFlex="100" #TableSort="matSort"
            class="mat-elevation-z8">

            <ng-container matColumnDef="action">
              <th mat-header-cell *matHeaderCellDef mat-sort-header></th>
              <td mat-cell *matCellDef="let area">
                <div *ngIf="isAdmin">
                  <button (click)="editArea(area)"  matTooltip="Edit Enclosed Area">
                    <mat-icon>edit</mat-icon>
                  </button>
                </div>
              </td>
            </ng-container>
            <ng-container matColumnDef="complaintId">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Complaint ID</th>
              <td mat-cell *matCellDef="let area">
                {{area.complaintId}}
              </td>
            </ng-container>
            <ng-container matColumnDef="comments">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Visit Date</th>
              <td mat-cell *matCellDef="let area">
                {{area.visitDate}}
              </td>
            </ng-container>
            <ng-container matColumnDef="visitDate">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Visit Comments</th>
              <td mat-cell *matCellDef="let area">
                {{area.comments}}
              </td>
            </ng-container>
            <ng-container matColumnDef="enclosedArea">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Has an Enclosed Area</th>
              <td mat-cell *matCellDef="let area" style="align-items: baseline;">
                  <span *ngIf="area.enclosedArea" style="display: flex; align-items: center; justify-content: center; color: red;">
                    <mat-icon style="color: red; margin-right: 5px;">warning</mat-icon>
                    Yes
                  </span>
                <span *ngIf="!area.enclosedArea" style="display: flex; align-items: center; justify-content: center;"> No</span>
              </td>
            </ng-container>
            <ng-container matColumnDef="enclosedAreaDetermination">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Most Recent Determination</th>
              <td mat-cell *matCellDef="let area">
                {{area.enclosedAreaDetermination}}
              </td>
            </ng-container>
            <ng-container matColumnDef="enclosedAreaDeterminationComments">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Determination Comment</th>
              <td mat-cell *matCellDef="let area">
                {{area.enclosedAreaDeterminationComments}}
              </td>
            </ng-container>
            <ng-container matColumnDef="editHistory">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Edit History</th>
              <td mat-cell *matCellDef="let area">
                <div *ngIf="isAdmin && area.editHistory.length > 0">
                  <button mat-raised-button (click)="showHistory(area)" matTooltip="History List">
                    View
                  </button>
                </div>
              </td>
            </ng-container>
            <ng-container matColumnDef="files">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Attachments</th>
              <td mat-cell *matCellDef="let area">
                <div class="flex flex-row">
                  <span *ngIf="area.files.length > 0">
                    <a (click)="showFiles(area)">{{area.files.length}}</a>
                  </span>
                  <div *ngIf="isAdmin" style="padding-left: 20px;">
                    <a title="Attach Enclosed Area Document" (click)="addFile(area)">
                      <mat-icon>attach_file</mat-icon>
                    </a>
                  </div>
                </div>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="expansion-element-row"></tr>
          </table>
        </div>
        <!-- <mat-paginator [pageSizeOptions]="[5, 10]" #TablePaginator="matPaginator" showFirstLastButtons></mat-paginator> -->
      </div>
    </mat-card>
    <br />

  </mat-card-content>

</mat-card>